import slidersStyle from "../partials/sliders-style";

export default {
  container: {
    ...slidersStyle,
  },
};
